const BASE_URL = 'https://api.sihatec.net';

const API_END_POINT = {
    SIGN_IN : `${BASE_URL}/auth/practitioner/login`,
    IS_AUTH: `${BASE_URL}/auth/verify-token`,
    SIGN_OUT: `${BASE_URL}/auth/logout`,
    FORGOT_PASSWORD: `${BASE_URL}/auth/practitioner/forgot-password`,
    VERIFY_FORGOT_PASSWROD: `${BASE_URL}/auth/practitioner/verify-forgot-password`,
    CHANGE_PASSWORD: `${BASE_URL}/auth/practitioner/change-password`,
    APPOINTMENTS: `${BASE_URL}/appointments`,   
    PREVIOUS_APPOINTMENT: `${BASE_URL}/appointments/previous`,  
    PATIENTS: `${BASE_URL}/practitioner/patients`,  
    CALENDAR_WEEKENDS:`${BASE_URL}/appointments/weekends`,
    CHANGE_EXCEPTION_DAYS : `${BASE_URL}/appointments/exceptions`,
    GENERATE_CALENDAR : `${BASE_URL}/appointments/generate`,
    EXCEPTIONS : `${BASE_URL}/appointments/exceptions`,
 };
export {BASE_URL, API_END_POINT};